<template>
  <div class="create-plan">
    <h3>Créer un nouveau plan</h3>

    <p>La largeur et la profondeur ne doivent pas dépasser 30 pieds.<br />La largeur doit être inférieure à la profondeur.</p>

    <div>
      <div class="form-group">
        <label for="exampleInputEmail1">Largeur en pieds</label>
        <input
          v-model="width"
          type="text"
          placeholder="Largeur en pieds"
          v-validate="'required|decimal'"
          name="largeur"
          class="form-control"
        />
        <small class="errors" v-show="errors.has('largeur')">{{ errors.first('largeur') }}</small>
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Profondeur en pieds</label>
        <input
          v-model="height"
          type="text"
          placeholder="Profondeur en pieds"
          name="profondeur"
          v-validate="'required|decimal'"
          class="form-control"
        />
        <small class="errors" v-show="errors.has('profondeur')">{{ errors.first('profondeur') }}</small>
      </div>
      <button type="submit" class="btn viewBtn" @click="StartPlan()">Démarrer la création</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      height: "",
      width: ""
    };
  },
  methods: {
    StartPlan: function() {
      this.$validator.validate().then(result => {
        if (!result) return; // client side error detected.

        var data = { height: this.height, width: this.width };

        var dheader = {
          "Content-Type": "application/json"
          //Authorization: "Token " + localStorage.getItem("token")
        };

        this.$http
          .post(this.$url_name + "/submission/", data, {
            headers: dheader
          })
          .then(response => {
            if (!localStorage.getItem("token")) {
              localStorage.setItem("soumissionUID", response.data.ident);
            }

            this.$router.push({
              name: "EditSoumission",
              params: { sid: response.data.ident }
            });
          })
          .catch(err => {
            console.log(err);

            if (err.status === 400) {
              Object.keys(err.body).forEach(key => {
                console.log("KEY: " + key);

                if (key == 0) {
                  this.$toasted.show(
                    err.body[key],
                    {
                      duration: 2000,
                      type: "error"
                    }
                  );
                } else {
                  this.$validator.errors.add({
                    id: err.body[key].id,
                    field: key,
                    msg: err.body[key][0],
                    scope: this.$options.scope
                  });
                }
              });
            }
          });
      });
    },
    ShowError: function(error) {
      if (err.status === 400) {
        this.api_errors = err.bodyText;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .create-plan{
    width: 50%;
    padding:10vh 10% 0 0;
    margin:0 auto;
  }
  .create-plan > p{
    font-size:0.9rem;
    line-height:120%;
    margin:2rem 0 0;
  }
  .create-plan > div {
    width: 90%;
    padding: 2rem 10% 10vh 0;
    margin: 0 auto;
  }
  @media (max-width:767px) {
    .create-plan{
      width: 70%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CreatePlan.vue